import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, restDelta: 0.001 });
  return <motion.div data-testid="scroll-progress" style={{ scaleX }} className="fixed top-0 left-0 right-0 h-[3px] bg-teal origin-left z-[60]" />;
}

export function Reveal({ children, delay = 0, className = "", as = "div", ...rest }) {
  const reduce = useReducedMotion();
  const Comp = motion[as];
  return (
    <Comp
      initial={{ opacity: 0, y: reduce ? 0 : 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
}

export const staggerParent = { hidden: {}, show: { transition: { staggerChildren: 0.06 } } };
export const staggerChild = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: EASE } },
};
